module.exports = __webpack_public_path__ + "img/avatar-01.e3b6470c.png";